// @flow
/**
 * User: Mike Chung
 * Date: 4/3/2018
 * Time: 11:56 AM
 */
import React from 'react';
import {Pagination, PaginationItem, PaginationLink} from "reactstrap";
import * as _ from 'lodash';
import {Link} from "react-router-dom";
import type {Location} from "../types/ReactRouterTypes";

export type PaginatorProps = {
    currentPage: number,
    pageItem: number,
    totalCount: number,
    generateLink: (page: number) => Location,
    onClickPage?: (page: number) => any
};

export type PageRange = {
    from: number,
    to: number
}

export default function Paginator(props: PaginatorProps) {

    const totalPage = Math.ceil(props.totalCount / props.pageItem);

    const pageRange: PageRange = {
        from: Math.max(props.currentPage - 2, 1),
        to: Math.min(Math.max(props.currentPage - 2, 1) + 5, totalPage)
    };

    let range: Array<number> = _.range(pageRange.from, pageRange.to);

    return (
        <Pagination>
            {props.currentPage > 1 &&
            <PaginationItem>
                <PaginationLink onClick={() => {
                    if (typeof props.onClickPage === 'function') {
                        props.onClickPage(1);
                    }
                }
                } previous tag={Link} to={props.generateLink(1)}/>
            </PaginationItem>
            }

            {
                _.map(range, (page: number) => {
                    return (

                        <PaginationItem key={page}>
                            <PaginationLink onClick={() => {
                                if (typeof props.onClickPage === 'function') {
                                    props.onClickPage(page);
                                }
                            }
                            } tag={Link} to={props.generateLink(page)}>
                                {page}
                            </PaginationLink>
                        </PaginationItem>
                    )
                })
            }

            {props.currentPage < totalPage &&
            <PaginationItem>
                <PaginationLink onClick={() => {
                    if (typeof props.onClickPage === 'function') {
                        props.onClickPage(totalPage);
                    }
                }
                } next tag={Link} to={props.generateLink(totalPage)}/>
            </PaginationItem>
            }
        </Pagination>);
};


// WEBPACK FOOTER //
// ./src/components/Paginator.js